<template>
    <div class="header-container">
        <div class="left-area-container">
            <div class="fa fa-chevron-left back" @click="navigateBack"></div>
        </div>
        <div class="center-area-container">
            <h1 v-text="title"></h1>
            <span v-text="subTitle"></span>
        </div>
            <div class="right-area-container">
            <img class="logo"  :src="logo">
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'HeaderComponent',
    props: ['title', 'subTitle'],
    computed: {
        ...mapGetters(['retailGeneralParams']),

        logo () {
            return this.retailGeneralParams?.TEMAESCURO
                ? require('@/assets/default/icons/no-cash-dark.svg')
                : require('@/assets/default/icons/no-cash.svg')
        }
    },
    methods: {
        navigateBack: function () {
            this.$router.back()
        }
    }
}
</script>
<style lang="less" scoped>
.header-container {
    position: relative;
    display: grid;
    grid-template-columns: 30px calc(100% - 60px) 30px;
    height: 30px;
    margin-bottom: 30px;

    img.logo {
        display: block;
        object-fit: contain;
        height: 32px;
        width: 32px;
        padding: 0;
        margin-top: 3px;
    }
    .center-area-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0;
        h1 {
            height: 20px;
            font-size: 16px;
            margin: 25 auto auto 0;
            padding: 0;
            font-weight: 600;
            text-align: center;
        }
        span {
            font-size: 14px;
        }
    }
    .left-area-container {
        .back {
            margin: 5px 0 0 auto;
            width: 24px;
            color: var(--iconColor);
        }
    }
}
</style>
